import { JARGON } from "../modules/constants"

//#region date formats
// Formats date either 'today at 10:15', 'yesterday ay 10:15' or '20/04/25 10:15'

const hourMillisecs = 60 * 60 * 1000
const dayMillisecs = 24 * hourMillisecs
const weekMillisecs = 7 * dayMillisecs

export const formatDateSmart = inputDate => {
  const date = new Date(inputDate)
  const now = new Date()

  const yesterday = new Date()
  yesterday.setDate(now.getDate() - 1)

  // Format time HH:mm
  const pad = num => String(num).padStart(2, '0')
  const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`

  if (isSameDay(date, now))
    return `today at ${timeStr}`

  if (isSameDay(date, yesterday))
    return `yesterday at ${timeStr}`

  // Use toLocaleDateString for dd/mm/yy format
  const dateStr = date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' })

  return `${dateStr} ${timeStr}`
}

// Accepts type string or date and returns formated date
// (eg "6 Feb") or JARGON.UNKNOWN if null
export const formatDate_D_MM = inputDate => {
  // console.log('inputDate:', inputDate)
  if (inputDate) {
    const date = new Date(inputDate)
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short'
    })
  } else
    return JARGON.UNKNOWN
}

const dateMultiplier = 10 ** 6
export const formatIntDate_D_MM = date => {
  // Formats a integer date - supplied as (int)((dateTime - new DateTime(1970, 1, 1)).Ticks / 1e10)
  // date is milliseconds since January 1, 1970, 00:00:00 UTC.
  if (date > -1) {
    const myDate = new Date(date * dateMultiplier)
    return myDate.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short'
    })
  } else
    return JARGON.UNKNOWN
}

//#endregion

export const isSameDay = (date, day) => {
  date = new Date(date)
  day = new Date(day)
  return date.getDate() === day.getDate() &&
    date.getMonth() === day.getMonth() &&
    date.getFullYear() === day.getFullYear()
}

// Returns true if inputDate is within the last n (eg 24) hours of now
export const isWithinLastNHours = (inputDate, hours) => {
  const diffMs = new Date().getTime() - new Date(inputDate).getTime()
  return diffMs >= 0 && diffMs <= hours * hourMillisecs
}

// Returns true if inputDate is within the last n (eg 7) days of today
export const isWithinLastNDays = (inputDate, days) => {
  const diffMs = new Date().getTime() - new Date(inputDate).getTime()
  return diffMs >= 0 && diffMs <= days * dayMillisecs
}
